import "./messages";
import type { ModuleDefinition } from "../types";
import { BILLING_REPORTS, IMPORTERS_READ } from "./permissions";

const screens = () => import("./screens");

export const importersModule: ModuleDefinition = {
  id: "importers",
  labelKey: "module.importers",
  nav: [
    { id: "migration-readiness", labelKey: "importers.readiness.title", to: "/importers/readiness", icon: "log", permission: IMPORTERS_READ },
    { id: "import-runs", labelKey: "importers.nav.runs", to: "/importers/runs", icon: "log", permission: IMPORTERS_READ },
    { id: "history-reconciliation", labelKey: "importers.nav.reconciliation", to: "/importers/history/reconciliation", icon: "table", permission: BILLING_REPORTS },
  ],
  routes: [
    { path: "importers", permission: IMPORTERS_READ, load: async () => ({ default: (await screens()).RunsIndexRedirect }) },
    { path: "importers/readiness", permission: IMPORTERS_READ, load: () => import("./screens/ReadinessPage") },
    { path: "importers/runs", permission: IMPORTERS_READ, load: async () => ({ default: (await screens()).RunsPage }) },
    { path: "importers/runs/:runId", permission: IMPORTERS_READ, load: async () => ({ default: (await screens()).RunPage }) },
    { path: "importers/history/reconciliation", permission: BILLING_REPORTS, load: async () => ({ default: (await screens()).ReconciliationPage }) },
  ],
};
